export default {
  生成失败: 'Failed to generate summary',
  AI总结汇总: 'AI Summary',
  AI格式整理失败: 'Failed to format content',
  格式整理成功: 'Content formatted successfully',
  'AI排版中...': 'AI formatting in progress ...'
};
